import React from 'react';
import PropTypes from 'prop-types';
import MessageField from 'components/field/MessageField/MessageField';
import theme from 'theme/theme';

const ErrorMessageField = (props) => {
    const { children, defaultStyle, style } = props;

    return (
        <MessageField additional={ Object.assign(defaultStyle, style) }>
            { children }
        </MessageField>
    );
};

ErrorMessageField.defaultProps = {
    defaultStyle: {
        backgroundColor: theme.palette.pipi,
        borderColor: theme.palette.colonialWhite,
    },
    style: {},
};

ErrorMessageField.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.element,
        PropTypes.object,
        PropTypes.string,
    ]),
    defaultStyle: PropTypes.object,
    style: PropTypes.object,
};

export default ErrorMessageField;



// WEBPACK FOOTER //
// ./src/components/field/MessageField/ErrorMessageField.js